import { color as d3Color, rgb } from "d3-color"

export function colorWithOpacity(color: string, opacity: number) {
  if (!color) { return "" }
  const c = d3Color(color)
  if (!c) { return color }

  c.opacity = opacity
  return c.toString()
}

export function darken(color: string, amount: number): string | "" {
  if (!color) { return "" }
  return rgb(color).darker(amount).formatHex()
}
